import api from "../api";

// User: Job Management
export const uploadImage = async (image) => {
  return api.getApi().post(api.getBaseUrl() + "jobs/upload", { image });
};

export const createJob = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "jobs", data);
};

export const getMyJobs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "jobs", { params });
};

export const getJob = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `jobs/${id}`);
};

export const getJobStats = async () => {
  return api.getApi().get(api.getBaseUrl() + "jobs/stats");
};

// Admin: Job Management
export const getAllJobs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/jobs", { params });
};

// Public: Download
export const getDownloadPage = async (token) => {
  return api.getApi().get(api.getBaseUrl() + `download/${token}`);
};

